import api from "../index";


// eslint-disable-next-line import/no-anonymous-default-export
export default {
    get_items: (params) => api.get(`/items/filter`, {
        params // Adjust the parameter name according to your API
    }),
}